"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "embedDashboard", {
  enumerable: true,
  get: function get() {
    return _embed.embedDashboard;
  }
});
Object.defineProperty(exports, "embedQSearchBar", {
  enumerable: true,
  get: function get() {
    return _embed.embedQSearchBar;
  }
});
Object.defineProperty(exports, "embedSession", {
  enumerable: true,
  get: function get() {
    return _embed.embedSession;
  }
});
Object.defineProperty(exports, "embedVisual", {
  enumerable: true,
  get: function get() {
    return _embed.embedVisual;
  }
});
var _embed = require("./embed");